@switch (columnName) {
  @case ('dateTime') {
    {{ element['date'] | date: dateFormat }}
  }
  @case ('action') {
    {{ element['workVersionReason'] | lowercase | translate }}
  }
  @case ('actionDoneBy') {
    <div class="row align-items-center">
      <mat-icon>perm_identity</mat-icon>
      <p class="text">{{ element['by'] }}</p>
    </div>
  }
  @case ('taskLogDetails') {
    <div class="task-log-details">
      @if (element.changes?.length) {
        @for (change of element.changes; track change.fieldName) {
          <div class="field-change">
            @if (change.fieldName === 'ParticipantsCount') {
              <span class="highlighted-text">
                {{
                  'performedWithXParticipants' | translate: { participantsCount: change.newValue }
                }}
              </span>
            } @else {
              <span class="highlighted-text">
                {{ getFieldLabelKey(change.fieldName) | translate }}
              </span>
              <span class="text-secondary">
                @if (change.oldValue) {
                  {{ 'wasMovedFrom' | translate }}
                  @if (isDateChange(change.fieldName, change.oldValue)) {
                    {{ change.oldValue | date }}
                  } @else {
                    {{ change.oldValue }}
                  }
                  {{ 'to' | translate | lowercase }}
                  @if (isDateChange(change.fieldName, change.newValue)) {
                    {{ change.newValue | date }}
                  } @else {
                    {{ change.newValue }}
                  }
                } @else {
                  {{ 'changedTo' | translate }}
                  @if (isDateChange(change.fieldName, change.newValue)) {
                    {{ change.newValue | date }}
                  } @else {
                    {{ change.newValue }}
                  }
                }
              </span>
            }
          </div>
        }
      }
      @if (element.comment) {
        <div class="field-change">
          <span class="highlighted-text">{{ 'comment' | translate }}</span>
          <span class="text-secondary">{{ element.comment }}</span>
        </div>
      }
      @if (element.description) {
        <div class="field-change">
          <span class="highlighted-text">{{ 'description' | translate }}</span>
          <span class="text-secondary">{{ element.description }}</span>
        </div>
      }
    </div>
  }
  @case ('view') {
    @if (element.workVersionReason === taskActionTypes.Perform) {
      <app-ui-button
        buttonType="secondary"
        text="{{ 'view' | translate }}"
        [routerLink]="performViewRoute + '/' + element['taskId'] + '/' + element['workVersionId']"
      ></app-ui-button>
    }
  }
  @case ('legacyAttachment') {
    @if (element.attachment) {
      @if (element.attachment.id !== 'new') {
        <a [href]="element.attachment.link" target="_blank" [download]="element.attachment.name">
          <mat-icon class="download-icon">download</mat-icon>
        </a>
      }
    }
  }
  @case ('attachments') {
    @if (element.attachmentsCount) {
      <div class="attachments-preview" (click)="openAttachments()">
        {{ element.attachmentsCount }}
        <mat-icon class="download-icon">attach_file</mat-icon>
      </div>
    }
  }
  @case ('trip') {
    {{ element?.trip?.name }}
  }
  @case ('haccpBy') {
    <div class="haccp-date">
      {{ element['haccpDate'] | date }} •
      <span class="haccp-time">{{ element['haccpDate'] | date: timeFormat }}</span>
    </div>
    {{ element['haccpBy'] }}
  }
  @default {
    <app-default-cell
      [element]="element"
      [columnName]="columnName"
      [parseLinks]="!!element.haccpId"
    ></app-default-cell>
  }
}
